export default "__VITE_ASSET__DBbnf6sh__"